<template>
  <div
    class="headersize introimg text-white position-relative"
    v-bind:style="[headAbsolute != '' ? { 'background-image': headAbsolute } : '']"
  >
    <div
      class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column bg-opacity"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IntroHeader",
  computed: {
    ...mapGetters(["hqDoc"]),
    headAbsolute() {
      if (this.hqDoc && this.hqDoc.ProfileImage != '') {
        return `url(${this.hqDoc.ProfileImage})`;
      } else {
        return "";
      }
    }
  }
};
</script>
